$(document).ready(function(){
  $('.fin-que .que-conti').click(function(){
    var $this = $(this);
    setTimeout(function(){
      $this.parents('.fin-que').find('.cntn_btn').click();
    }, 100);
  });
  $('.fin-que .cntn_btn').click(function(e){
    e.preventDefault();
    $('.fin-que').removeClass('active');
    $('.fin-que[data-que="'+$(this).attr('data-que')+'"], .fin-pc-topbar span[data-que="'+$(this).attr('data-que')+'"]').addClass('active');
  });
  $('.fin-que .back_btn').click(function(e){
    e.preventDefault();
    var i = Math.floor($(this).attr('data-que')) + 1;
    $('.fin-que, .fin-pc-topbar span[data-que="'+i+'"]').removeClass('active');
    $('.fin-que[data-que="'+$(this).attr('data-que')+'"]').addClass('active');
  });

  var rangeSlider = function(){
    var slider = $('.fin-que-range-slider'),
        range = $('.fin-que-range-slider input'),
        value = $('.range-slider__value');

    slider.each(function(){
      range.on('input', function(){
        $(this).parents(slider).find(value).html(this.value);
      });
    });
  };

  rangeSlider();
  
  $('.filters-bar h3').click(function(){
    $('.filters-categories').slideToggle();
  });

  $('ul.prod_tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
});